import React from 'react';
import { View } from 'react-native';

import { isEmpty as _isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import PlanFeatures from '../../../PlanFeatures';
import ChoosePlanSection from '../ChoosePlanSection';
import PlanSubscriptions from '../PlanSubscriptions';

import styles from './PlanContent.Styles';

const PlanContent = ({
  images,
  features,
  subscriptions,
  withWhyThisPlan,
  onWhyThisPlanPress,
  onSelectPlanPress,
  withChoosePlan,
  freeSubscriptionsKey,
  whyThisPlanKey,
  choosePlanKey,
  whyThisPlanStyle,
  choosePlanButtonType,
  choosePlanButtonTextStyle,
  featureTextStyle,
  subscriptionsTextStyle,
  ...props
}) => {
  return (
    <View {...props} style={[styles.planContentContainer]}>
      <PlanFeatures images={images} features={features} featureTextStyle={featureTextStyle} />

      {!_isEmpty(subscriptions) ? (
        <PlanSubscriptions
          i18nKey={freeSubscriptionsKey}
          subscriptions={subscriptions}
          subscriptionsTextStyle={subscriptionsTextStyle}
        />
      ) : undefined}
      {(withChoosePlan || withWhyThisPlan) && (
        <ChoosePlanSection
          choosePlanKey={choosePlanKey}
          whyThisPlanKey={whyThisPlanKey}
          withWhyThisPlan={withWhyThisPlan}
          onWhyThisPlanPress={onWhyThisPlanPress}
          onSelectPlanPress={onSelectPlanPress}
          withChoosePlan={withChoosePlan}
          whyThisPlanStyle={whyThisPlanStyle}
          choosePlanButtonType={choosePlanButtonType}
          choosePlanButtonTextStyle={choosePlanButtonTextStyle}
        />
      )}
    </View>
  );
};

PlanContent.defaultProps = {
  withChoosePlan: true,
  withWhyThisPlan: false,
};
PlanContent.propTypes = {
  freeSubscriptionsKey: PropTypes.string,
  choosePlanKey: PropTypes.string,
  whyThisPlanKey: PropTypes.string,
  withChoosePlan: PropTypes.bool,
  withWhyThisPlan: PropTypes.bool,
  features: PropTypes.array,
  subscriptions: PropTypes.array,
  onSelectPlanPress: PropTypes.func,
  onWhyThisPlanPress: PropTypes.func,
  whyThisPlanStyle: PropTypes.object,
  choosePlanButtonType: PropTypes.string,
  choosePlanButtonTextStyle: PropTypes.object,
  featureTextStyle: PropTypes.object,
  subscriptionsTextStyle: PropTypes.object,
  images: PropTypes.object,
};
export default PlanContent;
